import { ForecastParameterBase } from './base/forecast-parameter-base';

export class ForecastParameter extends ForecastParameterBase { }